import React from "react";
import { Link } from "react-router-dom";
import { Mail, Store, Bike, LifeBuoy, MapPin } from "lucide-react";
import { MarketingShell } from "@/components/marketing/MarketingShell";
import { Seo } from "@/components/marketing/Seo";
import { SITE, breadcrumbSchema } from "@/lib/seo";

const CARDS = [
  { icon: LifeBuoy, title: "Customer support", text: "Questions about an order, payment or your account? We're here to help." },
  { icon: Store, title: "Restaurant partnerships", text: "Want to list your restaurant on BiteGoFood and grow online orders?" },
  { icon: Bike, title: "Delivery partners", text: "Interested in delivering with BiteGoFood in your city?" },
];

export default function Contact() {
  return (
    <MarketingShell>
      <Seo
        title="Contact BiteGoFood – Support, Partnerships & Business Enquiries"
        description="Get in touch with BiteGoFood for customer support, restaurant partnerships, delivery partner enquiries and business questions. Email info@vs-solutions.org."
        path="/contact"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]}
      />
      <div className="max-w-3xl mx-auto px-4 py-14">
        <h1 className="font-display font-extrabold text-ink text-3xl sm:text-4xl">Contact BiteGoFood</h1>
        <p className="text-ink-600 mt-2">We'd love to hear from you. Reach the BiteGoFood team by email for support, partnerships and business enquiries.</p>

        <a href={`mailto:${SITE.email}`} className="mt-8 flex items-center gap-4 bg-coral-light rounded-2xl p-5 hover:bg-coral/15 transition-colors" data-testid="contact-email">
          <div className="w-12 h-12 rounded-2xl bg-coral flex items-center justify-center"><Mail size={22} className="text-white" /></div>
          <div><div className="text-xs text-ink-600">Email us</div><div className="font-bold text-ink text-lg">{SITE.email}</div></div>
        </a>

        <div className="grid sm:grid-cols-3 gap-4 mt-8">
          {CARDS.map((c) => (
            <div key={c.title} className="rounded-2xl border border-border p-5">
              <c.icon size={22} className="text-coral" />
              <h2 className="font-bold text-ink mt-3">{c.title}</h2>
              <p className="text-ink-600 text-sm mt-1">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-border p-6">
          <h2 className="font-display font-bold text-ink text-lg">Company</h2>
          <p className="text-ink-600 text-sm mt-2">{SITE.company}</p>
          <p className="text-ink-600 text-sm">Founder &amp; CEO: {SITE.founder}</p>
          <p className="text-ink-600 text-sm flex items-center gap-1.5 mt-1"><MapPin size={14} className="text-coral" /> {SITE.locations.join(", ")}</p>
          <p className="text-ink-600 text-sm mt-1">Website: <a href={SITE.url} className="text-coral font-semibold">{SITE.url}</a></p>
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/partner/register" className="bg-coral text-white font-bold px-5 py-3 rounded-full hover:bg-coral-hover transition-colors">Add your restaurant</Link>
          <Link to="/rider/register" className="bg-white border border-border text-ink font-bold px-5 py-3 rounded-full hover:border-coral hover:text-coral transition-colors">Become a delivery partner</Link>
        </div>
      </div>
    </MarketingShell>
  );
}
